var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"width":"10","height":"7","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M9 1L3.5 6.5 1 4","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round"}})])}
var staticRenderFns = []

export { render, staticRenderFns }